
riot.tag2('price-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Цена товаров</div>\n    </yield>\n    <yield to="body">\n      <form onchange="{change}" onkeyup="{change}">\n        <div class="form-group">\n          <label class="control-label">Цена</label>\n          <input class="form-control" name="price" step="0.01" value="{item.price}" type="{\'number\'}">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Валюта</label>\n          <select class="form-control" name="currency" value="{item.currency}">\n            <option each="{c, i in parent.currencies}" value="{c.name}" __selected="{c.name == item.curr}" no-reorder>{c.title}</option>\n          </select>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Выбрать</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

API.request({
    object: 'Currency',
    method: 'Fetch',
    data: {},
    success: function success(response) {
        self.currencies = response.items;
        self.update();
    }
});

self.on('mount', function () {
    self.tags['bs-modal'].mixin('change');
    self.tags['bs-modal'].item = {
        price: opts.price || 0
    };
});
});


// WEBPACK FOOTER //
// ./pages/products/products/price-modal.tag